// istanbul ignore file
import { createSelector } from '@reduxjs/toolkit'

import { IBookingStatus } from '@flecto-io/core/src/interfaces'
import { type RootState } from '@flecto-io/core/src/store/redux'
import { type UNSAFE_any } from '@flecto/types'

export const bookingSelector = createSelector(
  (root: RootState) => root.bookings.booking,
  (rawBooking) => ({
    isLoading: rawBooking.loading,
    total_pickup: rawBooking.data?.meta.total_picked_up_quantity,
    total_returned: rawBooking.data?.meta.total_returned_quantity,
    total_reserved: rawBooking.data?.booking_items?.reduce(
      (acc: UNSAFE_any, item: UNSAFE_any) => {
        return acc + Number(item.quantity)
      },
      0
    ),
    show: [IBookingStatus.completed, IBookingStatus.ongoing].includes(
      rawBooking.data?.status as IBookingStatus
    ),
  })
)
